import { Modal } from "./modal";

const WithdrawShift = { Modal };

export default WithdrawShift;
